import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnIntegrationsAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';

@Component({
  selector: 'sn-briefcam-case-search-dialog',
  templateUrl: './briefcam-case-search-dialog.component.html',
  styleUrls: ['./briefcam-case-search-dialog.component.scss'],
})
export class BriefcamCaseSearchDialogComponent implements OnInit, OnDestroy {
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'name',
      type: 'input',
      templateOptions: {
        label: 'Name',
        type: 'text',
        required: true,
      },
    },
    {
      key: 'description',
      type: 'input',
      templateOptions: {
        label: 'Description',
        type: 'text',
        required: true,
      },
    },
  ];

  public formModel: any = {};
  private readonly _destroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _dialogRef: MatDialogRef<BriefcamCaseSearchDialogComponent>,
    private readonly _integrationAPI: SnIntegrationsAPI,
  ) {}

  public ngOnInit(): void {
    this.formModel.name = this.data ? this.data : null;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submit(): void {
    const params = {
      name: this.formModel.name,
      description: this.formModel.description,
    };

    this._integrationAPI
      .createBriefcamCase(params)
      .pipe(takeUntil(this._destroy$))
      .subscribe((group) => {
        this._dialogRef.close(group);
      });
  }

  public close(): void {
    this._dialogRef.close();
  }
}
